<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useLocalization } from './composables/useLocalization'
import { useAuthStore } from './stores/auth'
import { useRoute } from 'vue-router'
import MOPToast from './components/primevuecomponents/messages/MOPToast/MOPToast.vue'

const { isRTL, initializeLanguage } = useLocalization()
const authStore = useAuthStore()
const route = useRoute()

// Initialize language and direction on component mount
onMounted(() => {
  initializeLanguage()
  authStore.restoreState()
})

// Watch for route changes and scroll to top
watch(
  () => route.fullPath,
  () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }
)
</script>

<template>
  <div class="app-wrapper">
    <MOPToast />
    <main :dir="isRTL ? 'rtl' : 'ltr'">
      <router-view></router-view>
    </main>
  </div>
</template>

<script lang="ts">
export default {
  name: 'App'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');

:root {
  --font-family: 'Poppins', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

body {
  font-family: var(--font-family);
  margin: 0;
  padding: 0;
}

.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
